import {
  REQUEST_ALERTS,
  RECEIVE_ALERTS_SUCCESS,
  ADD_ALERT,
  EDIT_ALERT,
  DELETE_ALERT
} from '../actions/alerts'

const initialState = {
  alerts: [],
  loading: false,
  error: null
}

export default (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_ALERTS:
      return {
        ...state,
        loading: true
      }
    case RECEIVE_ALERTS_SUCCESS:
      return {
        ...state,
        loading: false,
        alerts: action.alerts
      }
    case ADD_ALERT:
      action.alert = {
        ...action.alert,
        id: state.alerts[state.alerts.length - 1].id + 1
      }
      return {
        ...state,
        alerts: [...state.alerts, action.alert]
      }
    case EDIT_ALERT:
      return {
        ...state,
        alerts: state.alerts.map(alert => {
          if (alert.id === action.alert.id) {
            return { ...alert, ...action.alert }
          }
          return alert
        })
      }
    case DELETE_ALERT:
      return {
        ...state,
        alerts: state.alerts.filter(a => a.id !== action.id)
      }
    default:
      return {
        ...state,
        loading: false,
        error: action.error
      }
      return state
  }
}